"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountryCard = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _currency = require("../../utils/currency");
var _date = require("../../utils/date/date");
var _PriceLink = _interopRequireDefault(require("../PriceLink"));
var _CountryImage = require("./SubComponents/CountryImage");
// Utils:

// Components:

var CountryCard = exports.CountryCard = function CountryCard(_ref) {
  var className = _ref.className,
    isMobile = _ref.isMobile,
    image = _ref.image,
    text = _ref.text,
    startDate = _ref.start_date,
    duration = _ref.duration,
    link = _ref.link,
    price = _ref.price,
    linked_regions = _ref.linked_regions;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var DOT = String.fromCharCode(8231);
  var formattedDate = (0, _date.formatDate)(startDate, 'dd MMM');
  var linkedRegionsArr = isMobile ? linked_regions.slice(0, 2) : linked_regions;
  return /*#__PURE__*/_react["default"].createElement(StyledCountryCard, {
    isMobile: isMobile,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_CountryImage.CountryImage, {
    imagePath: image
  }), /*#__PURE__*/_react["default"].createElement(CardContent, {
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(CardTitle, null, text), /*#__PURE__*/_react["default"].createElement("div", null, "".concat(formattedDate, " ").concat(DOT, " "), t('explore.recommendations.countryCard.night', {
    count: duration
  }), /*#__PURE__*/_react["default"].createElement(TourLink, {
    href: link
  }, t('filters.prices.from'), " ", (0, _currency.formatCurrency)(price))), !(0, _isEmpty2["default"])(linkedRegionsArr) ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(GreyText, null, t('explore.recommendations.countryCard.popularResorts')), linkedRegionsArr.map(function (region) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: region.text
    }, /*#__PURE__*/_react["default"].createElement(StyledItemTitle, null, region.text), /*#__PURE__*/_react["default"].createElement(StyledItemPrice, {
      link: region.link,
      price: region.price
    }));
  })) : null));
};
var StyledCountryCard = _styledComponents["default"].div.withConfig({
  displayName: "CountryCard__StyledCountryCard",
  componentId: "sc-ppm1qm-0"
})(["box-sizing:border-box;font-size:14px;height:180px;min-width:220px;max-width:359px;width:100%;color:", ";background-color:", ";border-radius:", ";box-shadow:0px 1px 2px rgba(210,208,197,0.9),0px 10px 15px rgba(216,214,204,0.9);@media (min-width:1580px){display:flex;flex-direction:row;min-width:359px;max-width:470px;}@media (min-width:1920px){min-width:470px;max-width:100%;flex-grow:1;}", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.blackLight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.shape.borderRadius;
}, function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile && "\n    font-size: 12px;\n    width: 200px;\n    height: 155px;\n    min-width: 200px;\n  ";
});
var TourLink = _styledComponents["default"].a.withConfig({
  displayName: "CountryCard__TourLink",
  componentId: "sc-ppm1qm-1"
})(["color:", ";text-decoration:none;cursor:pointer;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.blue;
});
var CardTitle = _styledComponents["default"].div.withConfig({
  displayName: "CountryCard__CardTitle",
  componentId: "sc-ppm1qm-2"
})(["font-weight:500;color:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.blackBase;
});
var GreyText = _styledComponents["default"].div.withConfig({
  displayName: "CountryCard__GreyText",
  componentId: "sc-ppm1qm-3"
})(["margin:7px 0 4px;color:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.coolGrey;
});
var CardContent = _styledComponents["default"].div.withConfig({
  displayName: "CountryCard__CardContent",
  componentId: "sc-ppm1qm-4"
})(["padding:7px 10px 0;height:", "px;min-width:220px;max-width:359px;width:100%;@media (min-width:1580px){max-width:220px;height:100%;}@media (min-width:1920px){max-width:100%;}"], function (_ref9) {
  var isMobile = _ref9.isMobile;
  return isMobile ? 105 : 130;
});
var StyledItemTitle = _styledComponents["default"].div.withConfig({
  displayName: "CountryCard__StyledItemTitle",
  componentId: "sc-ppm1qm-5"
})(["display:inline-block;text-overflow:ellipsis;overflow:hidden;vertical-align:top;white-space:nowrap;padding-right:4px;@media (max-width:1579px){max-width:calc(100% - 88px);}"]);
var StyledItemPrice = (0, _styledComponents["default"])(_PriceLink["default"]).withConfig({
  displayName: "CountryCard__StyledItemPrice",
  componentId: "sc-ppm1qm-6"
})(["display:inline-block;"]);